import React from 'react';
import { authRoles } from 'app/auth';

export const HeidiLmsConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	// Org admins only (NOT platform super-admins); the api re-checks org-admin +
	// LMS-enabled. SSO is org-scoped and the hub refuses privileged accounts.
	auth: authRoles.instructor,
	routes: [
		{
			// The tab is part of the address: the sidebar links straight to one,
			// and a professor can bookmark the list they actually use.
			path: '/heidi-lms/:tab(courses|build|teaching|advisor)?',
			component: React.lazy(() => import('./HeidiLms'))
		}
	]
};
